<template>
    <div>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Gerar tabela PDF
          </v-expansion-panel-header>
          <v-expansion-panel-content>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="3000"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="900px"
      :html-to-pdf-options="{ margin: [10, 10], filename: fileName() }"
      @hasDownloaded="setLoad()"
      ref="html2Pdf"
    >
    <!-- Seu conteúdo HTML aqui --> 
      <div slot="pdf-content">
        <div id="imprimir">
            <!-- <div ref="panelContents"> -->            
              <img style="margin: 0;" src="../assets/logo-tabela.jpg" title="World Encadernadora">
            <div style="width:900; align-items: center; margin-top: 10px;">
              <h3 style="color:#009688;margin: 5px;">Álbum Slim</h3>
              <table>
                <tr style="font-size: small;font-weight:bold; color:#fff;">
                  <th style="width:120px;background:#009688;">TAMANHO</th>
                  <th style="width:90px;background:#009688;" v-for="(lam, i) in produtos.laminasS" :key="i">
                    {{ lam }} LÂM.
                  </th>
                  <th style="width:70px; font-size: small;background:#009688;">
                    LÂM.EXTRA
                  </th>
                </tr>
                <tr v-for="(item, i) in produtos.tamanhoSlim" :key="i" class="linha">
                  <td style="font-size: small;text-align:center; border-bottom: solid 1px #000;">{{ item.tamanho }}</td>
                  <td style="text-align:center; border-bottom: solid 1px #000;" v-for="(lam, i) in produtos.laminasS" :key="i"> 
                    {{ setPrice(item.cm2, lam, 'slim') }}
                  </td>
                  <td style="text-align:center; border-bottom: solid 1px #000;">
                    {{ setPrice(item.cm2, 1, 'slim') }}
                  </td>
                </tr>
              </table>
            </div>
  
            <div style="width:900; align-items: center; margin-top: 10px;">
              <h3 style="color:#009688;margin: 5px;">Álbum Premium</h3>
              <table>
                <tr style="font-size: small;font-weight:bold; color:#fff;">
                  <th style="width:100px;background:#009688;">TAMANHO</th>
                  <th style="width:70px;background:#009688;" v-for="(lam, i) in produtos.laminasP" :key="i">
                    {{ lam }} Lâm.
                  </th>
                  <th style="width:70px; font-size: small;background:#009688;">
                    Lâm.Extra
                  </th>
                </tr>
                <tr v-for="(item, i) in produtos.tamanhoPremium" :key="i" class="linha">
                  <td style="font-size: small;text-align:center; border-bottom: solid 1px #000;">{{ item.tamanho }}</td>
                  <td style="text-align:center; border-bottom: solid 1px #000;" v-for="(lam, i) in produtos.laminasP" :key="i"> 
                    {{ setPrice(item.cm2, lam, 'premium') }}
                  </td>
                  <td style="text-align:center; border-bottom: solid 1px #000;">
                    {{ setPrice(item.cm2, 1, 'premium') }}
                  </td>
                </tr>
              </table>
            </div>

            <!-- <v-row class="justify-center mt-5">
              <h2 style="color:teal;">CAPAS</h2>
            </v-row> -->
            <div style="width:900; align-items: center; margin-top: 20px;">
              <table>
                <tr style="font-weight:bold; color:#fff;">
                  <th style="width:100px;background:#009688;">CAPAS</th>
                  <th style="width:80px;font-size: small;background:#009688;" v-for="(capa, i) in produtos.capa" :key="i">
                    {{ capa }}
                  </th>
                </tr>
                <tr v-for="(item, i) in produtos.tamanhoPremium" :key="i" class="linha">
                  <td style="font-size: small;text-align:center; border-bottom: solid 1px #000;">
                    {{ item.tamanho }}
                  </td>
                  <td style="text-align:center; border-bottom: solid 1px #000;" v-for="(capa, i) in produtos.capa" :key="i"> 
                    {{ setPrice(item.cm2, capa, 'capa') }}
                  </td>
                </tr>
              </table>
            </div>

            <!-- <p style="align-items: center; margin-top: 20px;"> -->
              <div style="width:900; align-items: center; margin-top: 40px;">
                <table style="font-size: small;">
                  <tr style="font-weight:bold; color:#fff;">
                    <th style="width:100px; background:#009688;">ACESSÓRIOS</th>
                    <th style="width:60px !important; background:#009688;font-size: x-small;" v-for="(ass, i) in produtos.acessorios" :key="i">
                      {{ ass }}
                    </th>
                  </tr>
                  <tr v-for="(item, i) in produtos.tamanhoPremium" :key="i" class="linha">
                    <td style="text-align:center; border-bottom: solid 1px #000;">
                      {{ item.tamanho }}
                    </td>
                    <td style="text-align:center; border-bottom: solid 1px #000;" v-for="(ass, i) in produtos.acessorios" :key="i"> 
                      {{ setPrice(item.cm2, ass, 'acessorios') }}
                    </td>
                  </tr>
                </table>
              </div>
              <p style="color: #009688;margin-top: 20px;">
                Tabela emitida em: {{ dataHora() }} - validade: {{ validade }}
              </p>
            <!-- </p> -->
            
          </div></div></vue-html2pdf>

            <v-row class="justify-center">
              <v-col cols="4">
                <v-row class="justify-center my-8">
                  Data: {{ hoje }}
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="itemsValidade"
                  v-model="validade"
                  item-text="text"
                  item-value="index"
                  label="Validade"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-row class="justify-center my-8">
                  <v-btn :loading="loading" small color="primary" class="mx-2" rounded @click="generateReport()">gerar PDF</v-btn>
                </v-row>
              </v-col>
            </v-row>
          <!-- </div> -->

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
        {{ msg }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="alert = false">
            X
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </template>
  
  <script>
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    name: "precos-cm2",
    components: {
      VueHtml2pdf
    },
    computed: {
    precosCm2() {
        return this.$store.getters.precosCm2;
      },
    produtos(){
      return this.$store.getters.produtos;
    }
    },
    watch: {
    precosCm2(p) {
        if (p){
          this.voltar()
        }
      }
    },
    mounted() {
      this.precos = this.precosCm2
    },
    data() {
      return {
        precos: [],
        perc: 0,
        alert: false,
        msg: "",
        hoje: new Date().toLocaleDateString("pt-BR"),
        loading: false,
        validade: "6 meses",
        itemsValidade: ['30 dias', '60 dias', '90 dias', '6 meses', '1 ano']
      }
    },
    methods: {
      generateReport() {
        this.loading = true;
        // this.disabled = true
        // this.datahora = this.dataHora()
        this.$refs.html2Pdf.generatePdf();
      },
      setLoad() {
        this.loading = false;
      },
      fileName() {
        let dt = this.hoje;
        let part = dt.split("/");
        const data = part[2] + part[1] + part[0];
        let nome = 'Tabela-World';
        const cliente = nome.replace(/\s+/g, "-");
        return cliente + "_" + data + ".pdf";
      },
      dataHora() {
        const date = new Date().toLocaleDateString("pt-BR");
        const hora = new Date().toLocaleTimeString("pt-BR");
        return date + " " + hora;
      },
      voltar() {
        this.precos = this.precosCm2
        this.perc = 0
      },
      setPrice(cm2, lam, tipo) {
        let preco = 0
        if (tipo === "slim"){
          let slim = this.precosCm2[1].valor
          if (slim.includes(",")) {
            slim = slim.replace(",", ".");
          }
          preco = parseFloat(cm2) * parseFloat(lam) * slim
        }
        if (tipo === "premium"){
          let premium = this.precosCm2[0].valor
          if (premium.includes(",")) {
            premium = premium.replace(",", ".");
          }
          preco = parseFloat(cm2) * parseFloat(lam) * premium
        }
        if (tipo === "capa"){
          let valor = "0.1"
          for (let i = 0; i < this.precosCm2.length; i++) {
            let item = this.precosCm2[i]
            if (item["tipo"] === lam) {
              let capa = item['valor']
              if (capa.includes(",")) {
                capa = capa.replace(",", ".");
              }
              valor = parseFloat(capa) * parseFloat(cm2)
            }
          }
          preco = valor
        }
        if (tipo === "acessorios"){
          let valor = "0.1"
          for (let i = 0; i < this.precosCm2.length; i++) {
            let item = this.precosCm2[i]
            if (item["tipo"] === lam) {
              let ass = item['valor']
              if (ass.includes(",")) {
                ass = ass.replace(",", ".");
              }
              if (parseFloat(ass) > 10) {
                valor = parseFloat(ass)
              } else {
                valor = parseFloat(ass) * parseFloat(cm2)
              }
            }
          }
          preco = valor
        }
        return parseFloat(preco).toFixed(2)
      },
    //   printPanel() {
    //   // Captura o conteúdo do painel específico
    //   const panelContent = this.$refs.panelContents;
    //   if (panelContent) {
    //     const printWindow = window.open("", "_blank");
    //     printWindow.document.write(`
    //       <html>
    //         <head>
    //           <title>Impressão</title>
    //         </head>
    //         <body>
    //           ${panelContent.innerHTML}
    //         </body>
    //       </html>
    //     `);
    //     printWindow.document.close();
    //     printWindow.print();
    //   } else {
    //     console.error("Painel não encontrado!");
    //   }
    // },
      showAlert() {
          this.msg = "Salvo com sucesso!!";
          this.alert = true;
        },
    },
  };
  </script>
  
  <style scoped>
    .coluna1 {
      text-align:center;
      border-bottom: solid 1px #000;
    }
    .linha:nth-child(even) {
      background-color: #f2f2f2;
    }
    .linha:nth-child(odd) {
      background-color: #ffffff;
    }
    .valor{
      padding-left: 10px;
    }
  </style>
